import React from "react"

import { AdUnit, TitleWrapper, IconWrapper, InfoIcon, Tooltip, TooltipText } from "./styles"

const NetworkAd = ({
  className,
  dataId,
  unitName,
  articleId,
  nsfw = false,
  hideTitle,
  isInlineAd = false,
  position,
  maxHeight,
  ...props
}) => {
  const unitNameWithNsfw = `${unitName}${nsfw ? "_NSFW" : ""}`

  return (
    <AdUnit
      className={className}
      data-exp-id={dataId}
      {...props}
      isInlineAd={isInlineAd}
      maxHeight={maxHeight}
    >
      {!hideTitle && (
        <TitleWrapper>
          <h5>Advertisement</h5>
          <IconWrapper tabIndex={0}>
            <InfoIcon id="info-icon" height="19px" width="19px" />
          </IconWrapper>
          <Tooltip>
            <TooltipText>
              This ad is displayed using third party content and we do not control its accessibility
              features.
            </TooltipText>
          </Tooltip>
        </TitleWrapper>
      )}
      {position ? (
        <div
          className={`network-ad htlad-${unitNameWithNsfw}`}
          data-unit-name={unitNameWithNsfw}
          id={`${unitNameWithNsfw}${position ? `_${articleId}_${position}` : ""}`}
          key={`${unitNameWithNsfw}-${position}`}
        />
      ) : (
        <div className={`network-ad htlad-${unitNameWithNsfw}`} />
      )}
    </AdUnit>
  )
}

export default NetworkAd
